
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import './style.css';
import firebase from '../../config/firebase'

import Masteradmin from '../../config/firebase_admin'
import { useState, useEffect } from "react";

function Dashboard() {
const [data,setdata]=useState([])
const [load,setload]=useState('block')




useEffect(()=>{
 
  firebase.firestore().collection('users')
  .onSnapshot(function(querySnapshot) {
    let arr = []
    querySnapshot.forEach(function(doc) {
        arr.push(doc.data())
    });

    arr.sort(function(a, b){return b.date - a.date})
setdata(arr)
setload('none')
console.log("cdcsc",arr);
  })
},[])


const license=(c,v)=>{


  if(c==true)
  {




    if (v.welcome=='yes') {
    firebase.firestore().collection("users")
  .doc(v.admin_uid)
  .update({
   approved:'yes'
  });
    }
     
    else {
      Masteradmin.auth().sendPasswordResetEmail(v.email)
  .then(() => {
    // Password reset email sent!
    // ..
    firebase.firestore().collection("users")
    .doc(v.admin_uid)
    .update({
     welcome:'yes',
     approved:'yes'

    });
  })
  .catch((error) => {
    var errorCode = error.code;
    var errorMessage = error.message;
    console.log("e>>>>>>>",errorMessage);
    // alert(error.message)
    // ..
  });
      
    }
    console.log(v);



  }




  else{
    firebase.firestore().collection("users")
    .doc(v.admin_uid)
    .update({
     approved:'no'

    });
  }

}

  return (
    <>{localStorage.getItem('*Required Cdn')==null?
    window.location.replace('/authentication/sign-in')
    :

    <DashboardLayout>
    <DashboardNavbar />
    <div  id="centerME">
    <div style={{display:load}}class="loading_hac_2">Loading&#8230;</div>

    <div className="boxStAc1">
   
   
      <table id='tableAll'>
        <thead>
          <tr>
            <th scope="col">Sr No.</th>
            <th scope="col" colSpan={'2'}>Hotel Manager Name
              </th>
            <th scope="col">Email</th>
            <th scope="col">Phone</th>
            
            <th scope="col">Availablility</th>
            
          </tr>
        </thead>
        <tbody>

{data.map((v,i)=>{
  return(

          <tr>
            <td data-label="Sr No.">{i}</td>
            
            <td data-label="Hotel Manager Name" colSpan={'2'}>{v.name}</td>
            <td data-label="Email">{v.email}</td>
            <td data-label="Phone">{v.number}</td>
            <td data-label='Availablility'>
              <div id="centerW">
              <label class="switch">
<input type="checkbox" defaultChecked={v.approved=='yes'?true:false} onClick={(e)=>{license(e.target.checked,v)}}/>


<span class="slider round"></span>
</label>
              </div>
            </td>
           
          </tr>
  )
})}

        
        </tbody>
      </table>
    </div>
  </div>
  </DashboardLayout>
  }
  </>

  );
}

export default Dashboard;
